 const updateObject = (oldObject, updatedValues) => ({
    ...oldObject,
    ...updatedValues,
  })

export default updateObject;
